(function () {
  var SECTION_SELECTOR = '.oddit-section-banner-ticker';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function getTrackGap() {
      var trackStyle = getComputedStyle(track);
      return parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
    }

    function ensureCoverage() {
      var setWidth = firstSet.scrollWidth;
      var gap = getTrackGap();
      var viewportWidth = section.getBoundingClientRect().width || window.innerWidth;
      var minTrackWidth = viewportWidth + setWidth + gap;
      var safety = 20;
      while (track.scrollWidth < minTrackWidth && safety-- > 0) {
        var clone = firstSet.cloneNode(true);
        clone.removeAttribute('data-marquee-set');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-setting-id]').forEach(function (el) {
          el.removeAttribute('data-setting-id');
        });
        track.appendChild(clone);
      }
    }

    function measure() {
      ensureCoverage();
      var setWidth = firstSet.scrollWidth;
      var distance = setWidth + getTrackGap();
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function handleReducedMotionChange(e) {
      if (e.matches) {
        disable();
      } else {
        enable();
      }
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleReducedMotionChange);
    }

    function handleVisibilityChange() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      handleReducedMotionChange: handleReducedMotionChange,
      handleVisibilityChange: handleVisibilityChange
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion && state.reducedMotion.removeEventListener) {
      state.reducedMotion.removeEventListener('change', state.handleReducedMotionChange);
    }
    document.removeEventListener('visibilitychange', state.handleVisibilityChange);
  }

  function initSection(section) {
    if (!section) return;
    var state = { marquee: initMarquee(section) };
    sectionState.set(section, state);
  }

  function destroySection(section) {
    if (!section) return;
    var state = sectionState.get(section);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();